module.exports = __webpack_public_path__ + "img/logo-merah.ce730244.png";